import StoredLayout from '../../layouts/StoredLayout'
import ArticleAdmin from './ArticleAdmin'
export default StoredLayout(ArticleAdmin)
